import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaTotalTentativas = (): TabelaColuna => ({
  Chave: 'totalTentativas',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 80 }}>Total Tent.</div>
})
